import React, { useState, useEffect } from "react";
import { useData } from "../../../components/firebase/DataProvider";
import { firefunctions } from "../../../components/firebase/FirebaseProvider";
import tableIcons from "../../../components/tableicon/table-icons";
import MaterialTable from "material-table";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  tableAllTransaksi : {
    "& table": {
      marginLeft: "0",
      marginRight: '0',
      [theme.breakpoints.up(1015)]: {
        marginLeft: '20px',
        marginRight: '20px',
      },
    },
    "& .MuiTableCell-root": {
      padding: '5px'
    },
    "& th": {
      textAlign: 'center'
    }
  }
}));


function AllTransaksi() {
  const classes = useStyles();
  const { profil } = useData();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [table, setTable] = useState({
    columns: [
      { title: "paid_at", field: "paid_at" },
      { title: "kode_order", field: "kode_order" },
      { title: "nama_penerima", field: "nama_penerima" },
      { title: "no_penerima", field: "no_penerima" },
      { title: "location", field: `location` },
      { title: "total_pembayaran", field: "total_pembayaran" },
      { title: "products", field: "products" },
    ],
    data: [],
  });


  const getData = async () => {
    setLoading(true);

    try {
      const func = firefunctions.httpsCallable("getListPaidTransaksi");
      const data = {
        user_id: profil?.id,
      };
      const res = await func(data);
      setTable((table) => {
        return {
          ...table,
          data: res?.data?.map((doc) => {
            let paid_at = new Date(doc?.paid_at);
            return {
              ...doc,
              paid_at: paid_at?.toLocaleString('ID-id').replace(/\//g, "-"),
              kode_order: doc?.kode_order,
              nama_penerima: doc?.nama_penerima,
              no_penerima: doc?.no_penerima.replace(/\D/g, ""),
              location: doc?.location === "sellerapp" ? "tokorame" : "tukuyok",
              total_pembayaran: doc?.total_pembayaran,
              products: doc?.products
            };
          }),
        };
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);
  return (
    <div className={classes.tableAllTransaksi}>
      <MaterialTable
        title="Paid Transaksi"
        icons={tableIcons}
        columns={table.columns}
        data={table.data}
        components={{
          Container: (props) => <div {...props} elevation={0} />,
        }}
        localization={{
          body: {
            emptyDataSourceMessage: `Tidak Ada Data`,
          },
          toolbar: {
            searchTooltip: "Cari",
            searchPlaceholder: "Cari Data",
          },
          header: {
            actions: "Actions",
          },
          pagination: {
            labelRowsSelect: "Baris",
            labelDisplayedRows: " {from}-{to} Dari {count} Baris",
            firstTooltip: "Halaman Pertama",
            previousTooltip: "Halaman Sebelumnya",
            nextTooltip: "Halaman Selanjutnya",
            lastTooltip: "Halaman Terakhir",
          },
          
        }}
      />
    </div>
  );
}

export default AllTransaksi;
